import React, {PureComponent} from "react";
import {Icon, Button} from "semantic-ui-react";
import PropTypes from "prop-types";
import {Link} from "react-router-dom";

class EligibilityRequirements extends PureComponent {
  static propTypes = {
    hexColorCodeC: PropTypes.string,
    show : PropTypes.string,
  };

  render() {
    const { hexColorCodeC, show } = this.props;
    const IsGermanShoreShow =
      process.env.REACT_APP_IS_GERMAN_SHORE_SHOW === 'true';

    return (
        <div>
        <p><em>
          <strong style={{ color: `#${hexColorCodeC}` }}>
            {IsGermanShoreShow ? '' : 'All applicants must meet the eligibility requirements in order to be considered.'}
          </strong></em></p>
          <Link to="/eligibility">
            <Button className="ui huge black right labeled icon button">
              <Icon className="right chevron"></Icon>
            {IsGermanShoreShow ? 'Zu Informationszwecken' : 'View Eligibility Requirements'}
            </Button>
          </Link>
        </div>
    );
  }
}

export default EligibilityRequirements;



// WEBPACK FOOTER //
// ./src/components/common/EligibilityRequirements.js